/* eslint-disable @next/next/no-img-element */
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

import clsx from 'clsx';

import { Card, CardBody } from '@/components/Card';
import { SubscriptionCardProps } from '@/components/SubscriptionCards/SubscriptionCard';
import { SubscriptionIconsList } from '@/components/SubscriptionCards/SubscriptionIconsList';
import { SubscriptionTagsList } from '@/components/SubscriptionCards/SubscriptionTagsList';
import { TruncatedText } from '@/components/TruncatedText';

import styles from '@/contexts/VerificationContext/VerificationModal/SubscriptionVerification/SubscriptionCard.module.scss';

import { SelectSubscriptionPeriod } from '@/views/SubscriptionView/PurchasingSubscriptionsView/SelectSubscriptionPeriod';

// =================================================================

export enum SubscriptionTypeEnum {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  DEFAULT = 'default',
}

export type SubscriptionsCardProps = Omit<SubscriptionCardProps, 'type'> & {
  type: SubscriptionTypeEnum;
};

// =================================================================

export const SubscriptionsCard = (props: SubscriptionsCardProps) => {
  const { subscription, bgImage, logoSvg: LogoSVG, type } = props;

  const { title, tags, icons, description } = subscription;

  return (
    <Card className={clsx(styles.subscriptionCard, styles[type])}>
      <div className={styles.backgroundImage}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img src={bgImage} alt={title} />
      </div>
      <CardBody className={styles.subscriptionCardBody}>
        <div className={styles.subscriptionHeader}>
          {LogoSVG ? (
            <LogoSVG className={styles.logoSvg} />
          ) : (
            <h2 className={styles.title}>{title}</h2>
          )}

          {description && (
            <TruncatedText as="p" lines={4} className={styles.description}>
              {description}
            </TruncatedText>
          )}
        </div>

        <div className={styles.subscriptionInfo}>
          {tags && (
            <SubscriptionTagsList
              type={
                type === SubscriptionTypeEnum.PRIMARY
                  ? SubscriptionTypeEnum.PRIMARY
                  : SubscriptionTypeEnum.SECONDARY
              }
              tags={tags}
              className="py-3"
            />
          )}
          {icons && <SubscriptionIconsList icons={icons} className={styles.iconsListWrapper} />}
        </div>

        <SelectSubscriptionPeriod className={styles.subscriptionPeriodWrapper} />
      </CardBody>
    </Card>
  );
};

// =================================================================

export const SubscriptionSkeletonCard = () => {
  return (
    <SkeletonTheme baseColor="#0F0F12" highlightColor="#47474A">
      <Skeleton className={styles.subscriptionCardSkelton} height={183.6} borderRadius={16} />
    </SkeletonTheme>
  );
};
